import { render, staticRenderFns } from "./NotificationBellComponent.vue?vue&type=template&id=2252834d&scoped=true"
import script from "./NotificationBellComponent.vue?vue&type=script&lang=ts"
export * from "./NotificationBellComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2252834d",
  null
  
)

export default component.exports